export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";